<dx-drop-down-box
  #footerLocationDropDown
  [value]="value"
  (valueChange)="updateValue($event)"
  valueExpr="id"
  displayExpr="name"
  [label]="getLabel()"
  [dataSource]="data"
  stylingMode="outlined"
  [showClearButton]="true"
  (onValueChanged)="close()"
>
  <div *dxTemplate="let content of 'content'">
    <dx-tree-view
      [searchEnabled]="true"
      [dataSource]="data"
      [selectionMode]="'single'"
      dataStructure="plain"
      keyExpr="id"
      displayExpr="name"
      [selectByClick]="true"
      (onItemSelectionChanged)="onSelected($event)"
    >
      <div *dxTemplate="let item of 'item'">
        <div class="tree-item" [class.no-footer]="!item.reportFooter">
          {{ item.name }}
          <span *ngIf="!item.reportFooter" class="hint"> ({{ 'COMMON.NO-FOOTER' | translate }})</span>
        </div>
      </div>
    </dx-tree-view>
  </div>
</dx-drop-down-box>